import React, { useState } from 'react';
import { maturacaoApi } from '../api/api';

interface Props {
  onClose: () => void;
  onUpgrade: () => void;
}

export default function MaturadorPopup({ onClose, onUpgrade }: Props) {
  const [naoMostrarMais, setNaoMostrarMais] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleClose = async () => {
    if (naoMostrarMais) {
      setBusy(true);
      try { await maturacaoApi.dispensarPopup(); } catch {}
      setBusy(false);
    }
    onClose();
  };

  const handleUpgrade = async () => {
    if (naoMostrarMais) {
      try { await maturacaoApi.dispensarPopup(); } catch {}
    }
    onUpgrade();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" style={{ background: 'rgba(15, 23, 42, 0.55)' }}>
      <div
        className="w-full max-w-md bg-white rounded-card overflow-hidden shadow-2xl"
        style={{ border: '1px solid #E2E7F1' }}
      >
        {/* Header decorativo */}
        <div className="px-6 pt-6 pb-4" style={{ background: 'linear-gradient(135deg, #3B82F6 0%, #3B82F6 100%)' }}>
          <div className="flex items-start justify-between">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center flex-shrink-0">
              <svg className="w-6 h-6" fill="none" stroke="#3B82F6" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <button
              type="button"
              onClick={handleClose}
              disabled={busy}
              className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
              style={{ color: '#FFFFFF' }}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] mt-3" style={{ color: '#FFFFFF' }}>Novidade</p>
          <h2 className="text-xl font-extrabold mt-1 tracking-tight" style={{ color: '#FFFFFF' }}>
            Maturador de Chip
          </h2>
        </div>

        {/* Corpo */}
        <div className="px-6 py-5">
          <p className="text-sm text-ink-primary leading-relaxed">
            Aqueça seus números de WhatsApp automaticamente nos primeiros 14 dias com um sistema
            de envios graduais entre suas próprias sessões — reduz drasticamente o risco de banimento.
          </p>

          <ul className="mt-4 space-y-2 text-sm text-ink-primary">
            <li className="flex items-start gap-2.5">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5" style={{ background: 'rgba(37, 99, 235, 0.18)' }}>
                <svg className="w-3 h-3" fill="none" stroke="#3B82F6" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
              </span>
              Volume cresce de 10 até 130 msgs/dia
            </li>
            <li className="flex items-start gap-2.5">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5" style={{ background: 'rgba(37, 99, 235, 0.18)' }}>
                <svg className="w-3 h-3" fill="none" stroke="#3B82F6" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
              </span>
              Intervalos aleatórios — simula uso humano
            </li>
            <li className="flex items-start gap-2.5">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5" style={{ background: 'rgba(37, 99, 235, 0.18)' }}>
                <svg className="w-3 h-3" fill="none" stroke="#3B82F6" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
              </span>
              Acompanhamento do progresso em tempo real
            </li>
          </ul>

          {/* Preço */}
          <div className="mt-5 p-4 rounded-card flex items-center justify-between" style={{ background: '#F6F8FA', border: '1px solid #E2E7F1' }}>
            <div>
              <p className="text-xs text-ink-secondary">Add-on único de</p>
              <p className="text-2xl font-extrabold text-ink-primary tracking-tight">R$ 49,90</p>
            </div>
            <button
              type="button"
              onClick={handleUpgrade}
              disabled={busy}
              className="px-5 py-2.5 rounded-btn text-sm font-semibold hover:opacity-80 transition-opacity disabled:opacity-50"
              style={{ background: '#3B82F6', color: '#FFFFFF' }}
            >
              Fazer upgrade
            </button>
          </div>

          {/* Checkbox não mostrar mais */}
          <label className="mt-5 flex items-center gap-2 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={naoMostrarMais}
              onChange={e => setNaoMostrarMais(e.target.checked)}
              className="w-4 h-4 rounded accent-blue-500"
            />
            <span className="text-xs text-ink-secondary">Não mostrar essa mensagem novamente</span>
          </label>
        </div>
      </div>
    </div>
  );
}
